import _find from 'lodash/find';
// import _cloneDeep from 'lodash/cloneDeep';
import * as API from '../../../api';

const getCompanyPolls = async (context) => {
  const response = await API.getCompanyPolls();
  try {
    response.map((item) => {
      context.commit('addPoll', item.data);
    });
    context.commit('setCompanyPollsFetchedState', true);
  } catch (error) {
    throw error;
  }
  return response;
};

// const getProfile = async (context) => {
//   const response = await API.getUserPoll();
//   let profile = {};
//   profile.id = 'profile';
//   profile.pollId = 'profile';
//   profile.elements = response.data;
//   context.commit('addPoll', profile);
//   // context.dispatch('conditions/setConditions', response.data, { root: true });
//   return response;
// };

// const sendProfile = async (context) => {
//   let profile = _cloneDeep(context.rootGetters['answers/getAnswersByPoll']('profile'));
//   let profileObj = {};
//   profile.map((item) => {
//     delete item.pollId;
//     delete item.question;
//     let key = Object.keys(item)[0];
//     profileObj[key] = item[key];
//     return item;
//   });
//   const response = await API.setUserPoll(profileObj);
//   context.commit('setUserId', response.data);
//   return response;
// };

const getPoll = async (context, pollId) => {
  const response = await API.getPoll(pollId);
  // if (!response.data.elements.length) return false;
  context.commit('addPoll', response.data);
  context.dispatch('conditions/setConditions', response.data, { root: true });
  return response;
};

const setCurrentPollById = (context, pollId) => {
  const poll = _find(context.state.polls, (o) => {
    return o.id === pollId
  });
  context.commit('setCurrentPoll', poll);
};

const removePoll = (context, pollId) => {
  context.commit('removePoll', pollId);
  context.commit('answers/removeAnswersByPoll', pollId, { root: true });
};

const removeUnvalidPoll = (context, pollId) => {
  context.commit('removeUnvalidPoll', pollId);
};

const colorizeFailedPages = (context, pollsInfo) => {
  pollsInfo.unvalidPolls.map((value) => {
    let page = pollsInfo.polls.indexOf(_find(pollsInfo.polls, { 'id': value })) + 1;
    let pages = document.getElementsByClassName('polls-pag__btn');
    [].forEach.call(pages, function (item) {
      if (item.innerHTML === page.toString()) {
        item.classList.add('is-failed')
      }
    })
  })
}

export default {
  // getProfile,
  // sendProfile,
  getCompanyPolls,
  getPoll,
  setCurrentPollById,
  removePoll,
  removeUnvalidPoll,
  colorizeFailedPages
};
